import { render, staticRenderFns } from "./BtnInserirLicitacao.vue?vue&type=template&id=3c9948b2"
import script from "./BtnInserirLicitacao.vue?vue&type=script&lang=js"
export * from "./BtnInserirLicitacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports